<template>
  <div>
    <SectionHeader header="Authorised Officer" image="uiw-font-person" :active="shouldShow ? true : false" />
    <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded" v-if="shouldShow">
      <!-- <SubHeader header="Entity" /> -->
      <SubHeader header="Business Details" />
      <BusinessLookup v-if="showBusinessLookup" @closeBusinessLookup="closeBusinessLookup" @selectBusinessLookup="selectBusinessLookup" />
      <!-- <p>Please review and confirm your company details are correct, before nominating the authorised officer.</p> -->
      <p>Please review and confirm your business details are correct.</p>
      <QForm @submit.prevent="onConfirmHandler">
        <div class="row" v-if="showEntityFields">
          <!-- <InputField label="Legal Company Name" placeholder="Legal Company Name" v-model="form.name" :required="true" :readonly="true" /> -->

          <InputField label="Legal Name" placeholder="Legal Name" v-model="form.name" :required="true" :readonly="true" />
          <InputField label="Legal Company Name" placeholder="Legal Company Name" v-model="form.name" :required="true" :readonly="true" />
          <InputField
            :label="region === 'NZ' ? (isNZSoleTrader ? 'Trading as Name' : 'NZBN') : 'ABN'"
            v-model="form.abn"
            :required="true"
            :readonly="true"
          />
          <div class="q-pa-xs col-12 col-sm-6">
            <label class="field-label">Industry*</label>
            <QSelect
              dense
              emit-value
              outlined
              clearable
              v-model="$v.form.industry.$model"
              :options="industries"
              option-label="name"
              option-value="name"
              :loading="$apollo.queries.industries.loading"
              :error="$v.form.industry.$error"
              @input="selectIndustries"
              :disable="companyDetailsConfirmed"
            />
          </div>

          <div class="q-pa-xs col-12 col-sm-6">
            <label class="field-label">Sub Division*</label>
            <QSelect
              dense
              emit-value
              outlined
              clearable
              v-model="$v.form.subDivision.$model"
              :options="subDivisions"
              option-label="name"
              option-value="name"
              :loading="$apollo.queries.subDivisions.loading"
              :error="$v.form.subDivision.$error"
              @input="selectSubDivision"
              :disable="!form.industry || companyDetailsConfirmed"
            />
          </div>
          <div class="q-pa-xs col-12 col-sm-6">
            <label class="field-label">Sub Group*</label>
            <QSelect
              dense
              emit-value
              outlined
              clearable
              v-model="$v.form.subGroup.$model"
              :options="subGroups"
              option-label="name"
              option-value="name"
              :loading="$apollo.queries.subGroups.loading"
              :error="$v.form.subGroup.$error"
              :disable="!form.subDivision || companyDetailsConfirmed"
            />
          </div>
        </div>
        <div class="q-px-md q-py-md text-center" v-if="!companyDetailsConfirmed">
          <QBtn color="primary" outline no-caps @click="onBusinessLookup()" v-if="0"> Change </QBtn>
          <QBtn
            color="primary"
            type="submit"
            no-caps
            :disable="!(form.name && form.abn)"
            :loading="loadingOnConfirm"
            style="margin-left: 0px"
          >
            Confirm
          </QBtn>
        </div>
      </QForm>
      <div v-if="companyDetailsConfirmed">
        <br />
        <!-- <SubHeader header="Authorised Officer" info="test" dialog="primaryApplicantInfo" /> -->
        <SubHeader header="Authorised Officer (1)" info="test" dialog="primaryApplicantInfo" />
        <QForm @submit.prevent="onSubmit">
          <div class="q-pa-xs">
            <!-- new paragraph added -->
            <p>To proceed with the application, you must be an Authorised Officer of the above listed business.</p>
            <label class="field-label">1. Are you an Authorised Officer?*</label>

            <label class="block q-pb-xs">
              <QRadio v-model="owner" val="yes" label="Yes" />
              <QRadio v-model="owner" val="no" label="No" />
            </label>
          </div>
          <div v-if="owner == 'no'" class="q-pa-xs">
            <label class="field-label">2. Please nominate an Authorised Officer below.</label>
            <InputField
              label="First Name"
              placeholder="First Name"
              v-model="form.firstName"
              :required="true"
              :minLength="2"
              :maxLength="40"
            />
            <InputField label="Last Name" placeholder="Last Name" v-model="form.lastName" :required="true" :minLength="2" :maxLength="40" />
            <InputField
              label="Email"
              placeholder="Email"
              v-model="form.email"
              type="email"
              :required="true"
              :minLength="2"
              :maxLength="55"
            />
            <InputField
              v-if="region == 'NZ'"
              label="Mobile Number"
              placeholder="Mobile Number"
              v-model="form.phone"
              :required="true"
              type="tel"
              :minLength="9"
              :maxLength="12"
            />
            <InputField
              v-else
              label="Mobile Number"
              placeholder="Mobile Number"
              v-model="form.phone"
              type="tel"
              :required="true"
              :length="10"
            />
          </div>
          <div class="q-pa-xs" v-if="entityType != 'IND' && owner == 'yes'">
            <!-- <label class="field-label">2. Does the entity have more than 1 director?*</label> -->
            <label class="field-label">2. Does the business have more than 1 Authorised Officer?*</label>

            <label class="block q-pb-xs">
              <QRadio v-model="hasSecondaryApplicant" val="yes" label="Yes" />
              <QRadio v-model="hasSecondaryApplicant" val="no" label="No" />
            </label>
          </div>
          <div class="q-px-md q-py-md text-center">
            <QBtn color="primary" type="submit" no-caps :disable="!userInfoComputed" :loading="loadingOnSubmit">Continue</QBtn>
          </div>
        </QForm>
        <NewApplicantDialog
          v-if="showNewApplicantDialog"
          @closeNewApplicantDialog="closeNewApplicantDialog"
          :company="scoreboard.companyDetails.companyName"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn, QForm, QRadio, QSelect } from 'quasar';
import { mapState, mapActions } from 'vuex';
import SectionHeader from '../../components/Atoms/SectionHeader';
import SubHeader from '../../components/Atoms/SubHeader';
import InputField from '../../components/Atoms/InputField';
import NewApplicantDialog from '../../components/Molecules/NewApplicantDialog.vue';
import MutateSelectPrimaryApplicant from '../../graphql/mutations/MutateSelectPrimaryApplicant';
import MutateCreateOrUpdateProperty from '../../graphql/mutations/MutateCreateOrUpdateProperty';
import BusinessLookup from './BusinessLookup.vue';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';
import { GlobalDialog } from '../../components/Dialogs/GlobalDialog';
import QueryIndustries from '../../graphql/queries/Queryindustries';
import QuerySubDivisions from '../../graphql/queries/QuerySubDivisions';
import QuerySubGroups from '../../graphql/queries/QuerySubGroups';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'NominatePrimary',
  components: {
    SubHeader,
    SectionHeader,
    QBtn,
    QForm,
    QRadio,
    InputField,
    BusinessLookup,
    NewApplicantDialog,
    QSelect
  },
  mixins: [MyCustomFunctions],
  props: ['shouldShow'],
  data: function () {
    return {
      form: {
        name: null,
        abn: null,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        industry: null,
        subDivision: null,
        subGroup: null
      },
      companyDetailsConfirmed: false,
      owner: null,
      hasSecondaryApplicant: null,
      showEntityFields: true,
      showBusinessLookup: false,
      showNewApplicantDialog: false,
      loadingOnSubmit: false,
      loadingOnConfirm: false
    };
  },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard,
      user: (state) => state.auth.user
    }),
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    },
    entityType() {
      if (
        this.scoreboard &&
        this.scoreboard.entityDetails &&
        (this.scoreboard.entityDetails.entityType == 'IND' || this.scoreboard.entityDetails.entityType == 'Sole_Trader')
      )
        return 'IND';
      return null;
    },
    isNZSoleTrader() {
      if (this.region === 'NZ' && !this.scoreboard.companyDetails.nzbn && this.scoreboard.companyDetails.companyLegalName) return true;
      else return false;
    },
    userInfoComputed() {
      if (this.owner == 'yes') {
        if (this.entityType != 'IND' && this.hasSecondaryApplicant)
          return {
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            phone: ' '
          };
        else if (this.entityType == 'IND')
          return {
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            phone: ' '
          };
      } else {
        if (this.form.firstName && this.form.lastName && this.form.email && this.form.phone)
          return {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            email: this.form.email,
            phone: this.form.phone
          };
      }
      return false;
    }
  },
  created() {
    if (this.scoreboard && this.scoreboard.companyDetails && !this.companyDetailsConfirmed) {
      if (this.isNZSoleTrader) {
        this.form.name = this.scoreboard.companyDetails.companyLegalName;
        this.form.abn = this.scoreboard.companyDetails.companyName;
      } else {
        this.form.name = this.scoreboard.companyDetails.companyName;
        this.form.abn = this.scoreboard.companyDetails.abn;
      }
    }
    if (this.scoreboard && this.scoreboard.entityDetails) {
      this.form.name = this.scoreboard.entityDetails.entityName;
      this.form.abn = this.scoreboard.entityDetails.abn;
      this.form.industry = this.scoreboard.entityDetails.industry;
      this.form.subDivision = this.scoreboard.entityDetails.subDivision;
      this.form.subGroup = this.scoreboard.entityDetails.subGroup;
      this.companyDetailsConfirmed = true;
    }
  },
  apollo: {
    industries: {
      query: QueryIndustries,
      error: function () {
        this.$euiNotifications.emit({
          notification: GLOBAL_ERROR,
          action: () => {
            return this.$apollo.queries.industries.refresh();
          }
        });
      }
    },
    subDivisions: {
      query: QuerySubDivisions,
      variables() {
        return {
          param: this.form.industry.toString()
        };
      },
      skip() {
        return !this.form.industry;
      },
      error: function () {
        this.$euiNotifications.emit({
          notification: GLOBAL_ERROR,
          action: () => {
            return this.$apollo.queries.subDivisions.refresh();
          }
        });
      }
    },
    subGroups: {
      query: QuerySubGroups,
      variables() {
        return {
          industryId: this.form.industry.replace('/', '|').toString(),
          subDivisionId: this.form.subDivision.replace('/', '|').toString()
        };
      },
      skip() {
        return !this.form.subDivision;
      },
      error: function () {
        this.$euiNotifications.emit({
          notification: GLOBAL_ERROR,
          action: () => {
            return this.$apollo.queries.subGroups.refresh();
          }
        });
      }
    }
  },
  /*Industry validation */
  validations: {
    form: {
      industry: { required },
      subDivision: { required },
      subGroup: { required }
    }
  },
  methods: {
    ...mapActions({
      updateEntityDetailsState: 'vehicleApplication/updateEntityDetailsState',
      updateVehicleApplicationState: 'vehicleApplication/updateVehicleApplicationState'
    }),

    onConfirmHandler: async function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loadingOnConfirm = true;

      const entityObj = {
        entityName: this.form.name,
        abn: this.form.abn,
        industry: this.form.industry,
        subDivision: this.form.subDivision,
        subGroup: this.form.subGroup
      };
      await this.$apollo
        .mutate({
          mutation: MutateCreateOrUpdateProperty,
          variables: {
            applicationId: this.$store.getters['vehicleApplication/vehicleApplication']
              ? this.$store.getters['vehicleApplication/vehicleApplication'].applicationId
              : null,
            params: {
              value: 'entityObj',
              entityObj: entityObj,
              propertyFirst: 'entityDetails'
            }
          }
        })
        .then((data) => {
          entityObj.entityType = data?.data?.createOrUpdateProperty?.message ? data?.data?.createOrUpdateProperty?.message : null;

          if (entityObj.entityType === 'NOT_ALLOWED') {
            this.$euiNotifications.emit({
              notification: GlobalDialog,
              noEscDismiss: true,
              persistent: true,
              body:
                '<div class="col-12" style="text-align: center">' +
                '<img src="/assets/images/alert.png" class="header-logo" />' +
                '</div>' +
                '<p>Thank you, due to your entity type our team has been alerted and will be in contact to progress your application quickly.</p>',
              qCardStyle: {
                padding: '0',
                width: '400px',
                maxWidth: '80vw'
              },
              closeBtnStyle: {
                display: 'none'
              },
              btnOne: {
                label: 'Change',
                outline: true,
                color: 'primary',
                action: async () => {
                  this.showBusinessLookup = true;
                }
              },
              btnTwo: {
                label: 'Confirm & Logout',
                outline: false,
                color: 'primary',
                action: async () => {
                  this.$router.push({ name: 'logout' });
                  return;
                }
              }
            });
          } else {
            this.updateEntityDetailsState(entityObj);
            this.companyDetailsConfirmed = true;
          }
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loadingOnConfirm = false;
    },
    onSubmit: async function () {
      const userInfo = this.userInfoComputed;
      this.loadingOnSubmit = true;

      if (!userInfo) return;

      if (this.hasSecondaryApplicant)
        await this.updateVehicleApplication(this.hasSecondaryApplicant, 'entityDetails', 'hasSecondaryApplicant');

      await this.$apollo
        .mutate({
          mutation: MutateSelectPrimaryApplicant,
          variables: {
            isCurrentUserPrimary: this.owner == 'yes' ? true : false,
            vehicleApplicationStatus: this.owner ? this.owner : 'yes',
            userInfo: userInfo
          }
        })
        .then(async (data) => {
          if (this.owner == 'yes') {
            const primaryApplicant = data?.data?.selectPrimaryApplicant?.primaryApplicant
              ? data?.data?.selectPrimaryApplicant?.primaryApplicant
              : null;

            setTimeout(() => {
              this.$emit('primaryApplicantCreated', primaryApplicant);
            });
          } else
            setTimeout(() => {
              this.loading = false;
              this.showNewApplicantDialog = true;
            });
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loadingOnSubmit = false;
    },
    closeNewApplicantDialog: function () {
      this.showNewApplicantDialog = false;
      this.$router.push({ name: 'logout' });
    },
    onBusinessLookup: function () {
      this.showBusinessLookup = true;
    },
    closeBusinessLookup: function () {
      this.showBusinessLookup = false;
    },
    selectBusinessLookup: function (companySelected) {
      this.showEntityFields = false;
      this.form.name = companySelected.name;
      this.form.abn = companySelected.abn;
      setTimeout(() => {
        this.showEntityFields = true;
      });
    },
    selectIndustries: function () {
      this.form.subDivision = null;
      this.form.subGroup = null;
    },
    selectSubDivision: function () {
      this.form.subGroup = null;
    }
  }
};
</script>
